<div class="board-list-item-wrapper  p-lr-13 m-b-20">
    <div class="board-list-item-container flex flex-row flex-wrap full-grow-no-shrink-no-basis">
        <div class="board-list-item" *ngFor="let bucket of buckets" (click)="onClickBucket(bucket)">
            <div>{{bucket.title}} ({{bucket.noOfItems}})</div>
        </div>
        <div class="add-board">
            <div class="flex flex-row justify-start items-center" (click)="onClickAddBucket()">
                <i class="far fa-plus"></i>
                <div>Add Bucket</div>
            </div>
        </div>
    </div>
</div>
